var commitDate = '201908211325';

/**
 * openSmsAlarm.js
 */
var getAjax = function(url, param, callback) {
	$.ajax({
		type : 'POST',
		data : param,
		url: url,
		dataType: 'json'
	})
	.done(callback)
	.fail(function(jqXHR, ststus, error) {
		alert('방송알림 SMS 등록중 오류가 발생하였습니다.\n잠시후 다시 시도하십시오.');
	});
}

var AlarmObject = (new function(){
	var that = this;

	this.alarmOn = 'sprite-alarm_on';	// 방송알림 버튼 on style class.
	this.alarmOff = 'sprite-alarm';		// 방송알림 버튼 off style class.

    this.alarmOnText = '방송알림 등록완료';
    this.alarmOffText = '방송알림 등록하기';
	
	this.alarmRegisterLayerUrl = '/shop/tv/phoneAlarm/layer/SMSRegLayer.gs';
	this.alarmUpdateLayerUrl = '/shop/tv/phoneAlarm/layer/SMSUpdateLayer.gs';	
	this.alarmDeleteLayerUrl = '/shop/tv/phoneAlarm/layer/SMSDeleteLayer.gs';
	this.alarmReleaseUrl = '/shop/deleteBroadAlarm.gs';
	
	this.broadAlarmTarget = null;
	this.broadAlarmTargetId = null;

	this.isCategory = false;
	this.alarmType = null;
	this.gbn = '';
	this.targetGbn = {
		PRD : 'PRD',		// 단품
		DEAL : 'DEAL'		// 딜
	};
	
	/**
	 * 방송알림 페이지 카테고리에서 사용
	 */
	this.broadAlarmList = {};

	/**
	 * 방송알림 레이어 팝업 창 - 등록하기 시 사용
	 */
	this.addClassTvAlarmOn = function(prdId) {
		if (window.location.href.indexOf('/shop/myAlarm/myPhoneAlarmList.gs') > -1) { // 방송알림 페이지일 경우
			// 방송알림 Best, 찜한 브랜드 알림 버튼 ON
			$('section.mod-stage li[data-prdcd='+prdId+']').each(function() {
				$(this).find('i.'+that.alarmOff).attr({'class':that.alarmOn});
			});
		} else {
			if(that.targetGbn.PRD == that.gbn || that.targetGbn.DEAL == that.gbn || "TVPGM" == that.alarmType){
				$(that.broadAlarmTarget).addClass('on');
			}else{
				$(that.broadAlarmTarget).find('i').attr({'class':that.alarmOn});
	            $(that.broadAlarmTarget).find('span[name=broadAlarmTitle]').text(that.alarmOnText);
	        }
			if(that.isCategory) {
				categoryAlarmBtn.removeClass('lime');
				that.broadAlarmList[that.broadAlarmTargetId] = 99999;
			}
		}
	};

	/**
	 * 방송알림 레이어 팝업 창 - 해제하기 시 사용
	 */
	this.clearClassTvAlarm = function(prdId) {
		if (window.location.href.indexOf('/shop/myAlarm/myPhoneAlarmList.gs') > -1) { // 방송알림 페이지일 경우 
			// 방송알림 Best, 찜한 브랜드 알림 버튼 OFF
			$('section.mod-stage li[data-prdcd='+prdId+']').each(function() {
				$(this).find('i.'+that.alarmOn).attr('class', that.alarmOff);
			});
			
			// 방송알림 신청 내역 내 항목 삭제
			$('ul.panel-conts .prd-item[data-prdcd='+prdId+'][data-broadtype=PRDID]').each(function() {
				$(this).closest('li.panel-box').remove();
			})
			
			// 방송알림이 모두 삭제된 경우 '등록된 방송알림이 없어요' 노출
			if ($("#alarmPrdList .prd-item").length == 0) {
				if ($(".empty-data").length == 0) {
					$("#alarmPrdList").remove();
					var appendData = '<section class="empty-data line">' +
				                '<i class="gis-broadcast_notification"></i>' +
				                '<p class="ttl-base">등록된 방송알림이 없어요</p>' +
				                '<p class="sub">편성표에서 방송알림을 등록해보세요!</p>' +
				                '<button type="button" class="gui-btn leaf" onclick="location.href=\'/shop/tv/tvScheduleMain.gs?lseq=426134\'"><strong>편성표 보기</strong></button>' +
				            '</section>';
					$("#alarmInfoText").after(appendData);
				}
			}
		} else {
			if(that.targetGbn.PRD == that.gbn || that.targetGbn.DEAL == that.gbn || "TVPGM" == that.alarmType){
				$(that.broadAlarmTarget).removeClass('on');
			}else{
				$(that.broadAlarmTarget).find('i').attr('class', that.alarmOff);
	            $(that.broadAlarmTarget).find('span[name=broadAlarmTitle]').text(that.alarmOffText);
	        }
			if(that.isCategory) {
				categoryAlarmBtn.addClass('lime');
				that.broadAlarmList[that.broadAlarmTargetId] = null;
			}
		}
	};

	/**
	 * 이미 방송알림 되어있는지 여부
	 */
	this.isRegistered = function(id) {
		if(that.isCategory) return that.isRegisteredCategory(id);
		if(that.targetGbn.PRD == that.gbn || that.alarmType == "TVPGM") return $(that.broadAlarmTarget).hasClass('on');
		return $(that.broadAlarmTarget).find('i').hasClass(that.alarmOn);
	};
	
	this.isRegisteredCategory = function(id) {
		return (that.broadAlarmList[id] != null && that.broadAlarmList[id] != undefined);
	};

	/**
	 * 방송알림 등록 버튼 클릭 함수
	 */
	this.smsAlarm = function(target, type, prdId, prdName, gbn, addLseq, delLseq) {		
		// 방송알림 삭제 처리 중이면 리턴.
		if($('.toggle-cast-remove').is(':visible') == true) {
			return;
		}
		
		// 로그인 체크
		if(!that.isLogin()) {
			that.openLogin();
			return;
		}
		
		that.isCategory = (type == 'CATEGORY' ? true : false);	// 카테고리 여부
		that.alarmType = type; // 알림 타입
		that.broadAlarmTarget = $(target); // 방송알림 버튼
		that.broadAlarmTargetId = prdId;
		that.gbn = 'undefined' != typeof gbn ? gbn : '';
		
		// 등록 여부
		if(that.isRegistered(prdId)) {
			if (null != delLseq) LSeqUtil.clickLseqSend(delLseq);
			that.release(type, prdId);				// 방송알림 삭제
		} else {
			if (null != addLseq) LSeqUtil.clickLseqSend(addLseq);
			that.register(type, prdId, prdName);	// 방송알림 등록
		}
	};

	/**
	 * 로그인 여부
	 */
	this.isLogin = function() {
		var commonData = GsBase.commonData = GsBase.commonData || $('#common-data').getSelectorData();
		if (commonData) {
			return commonData.login;	
		}
	};

	/**
	 * 로그인 팝업창
	 */
	this.openLogin = function() {
		ShopBase.redirect.loginPage();
	};

	/**
	 * 방송알림 등록 레이어 오픈
	 */
	this.register = function(type, prdId, prdName, regNo, reAddYn) {
		prdName = (prdName == undefined ? '' : prdName);
		if ($('#smsAlarmLayerWrap').length == 0) $('body').append('<div id="smsAlarmLayerWrap" />');
		
		var param = {};
		param['type']		= type;
		param['prdId']		= prdId;
		param['prdName']	= prdName;
		param['regNo']		= regNo;
		param['reAddYn']	= reAddYn;
		
		$.ajax({
			url: that.alarmRegisterLayerUrl,
			data : param,
			type : 'GET',
		})
		.success(function(result) {
			$('#smsAlarmLayerWrap').html(result);
			var $smsAlarmLayer = $('#smsAlarmLayerWrap #smsAlarmLayer');

			if($smsAlarmLayer.attr('data-errmsg') == '') {
				$smsAlarmLayer.locationcenter(true).fadeIn(300);
				blindBox(1);
			} else {
				that.errorProcess($smsAlarmLayer.data('errmsg'));
				$('#smsAlarmLayerWrap').html('');
			}
		})
		.fail(function(jqXHR, ststus, error) {
			alert('오류가 발생하였습니다.\n잠시후 다시 시도하십시오.');
		});
	};
	
	/**
	 * 방송알림 삭제 레이어 오픈
	 */
	this.deleteLayer = function(type, prdId, prdName, regNo) {
		prdName = (prdName == undefined ? '' : prdName);
		var param = {};
		param['type'] = type;
		param['prdId'] = prdId;
		param['prdName'] = prdName;
		param['regNo'] = regNo;
		
		$.ajax({
			url: that.alarmDeleteLayerUrl,
			data : param,
			type : 'GET',
		})
		.success(function(result) {	
			if ($("#broadAlert")) {
				$("#broadAlert").remove();
			}
			$("body").append(result);
			var broadAlert = new GsBase.modal('#broadAlert');
			broadAlert.show('#broadAlert');
		})
		.fail(function(jqXHR, ststus, error) {
			alert('오류가 발생하였습니다.\n잠시후 다시 시도하십시오.');
		});
	};

	/**
	 * 방송알림 해제
	 */
	this.release = function(type, prdId) {
		var param = {};
		param['type']	= type;
		param['prdId']	= prdId;
		
		getAjax(that.alarmReleaseUrl, param, function(resultMessage) {
			if(resultMessage == 'MSG_SUCCESS') {
				if ("TVPGM" == that.alarmType) {
					that.clearClassTvAlarm(param['prdId']);
				} else {
					if ($('.toggle-cast-remove').length == 0) $('body').append('<span class="toggle-cast-remove" />');
					$('.toggle-cast-remove').locationcenter().fadeIn(200).delay(1000).fadeOut(200, function(){
						that.clearClassTvAlarm(param['prdId']);
					});
				}
			} else {
				that.errorProcess(resultMessage);
			}
		});
	};
	
	/**
	 * 방송알림 삭제
	 */
	this.remove = function(type, prdId, regNo, mode) {
		// 방송알림 삭제 알럿 close
		if (null != $('#broadAlert')) {
			GsBase.modal.Event.close('#broadAlert');
		}
		
		var param = {};
		param['type'] = type;
		param['prdId'] = prdId;
		param['regNo'] = regNo; // 삭제할 기존 알림 등록번호
		param['isReAdd'] = ("READD" == mode);
		
		getAjax(that.alarmReleaseUrl, param, function(resultMessage) {
			if ("READD" != mode) { // 재신청 아닌 경우에만
				if(resultMessage == 'MSG_SUCCESS') {
					window.location.reload();
				} else {
					that.errorProcess(resultMessage);
				}
			}
		});
	};	

	/**
	 * 에러메세지 처리
	 */
	this.errorProcess = function(resultMessage) {
		if (resultMessage == 'ERR_NOT_LOGIN') {
			ShopBase.redirect.loginPage();
		} else if (resultMessage == 'ERR_PHONE_EMPTY') {
			alert('먼저, 전화번호를 정확히 등록하여 주십시요.');
		} else if (resultMessage == 'ERR_MAX_ALARM_SIZE') {
			alert('방송알림은 30개까지만 등록하실 수 있습니다.');
		} else if (resultMessage == 'ERR_DUPLICATE_PRODUCT' || resultMessage == 'ERR_DUPLICATE_TITLE') {
			alert('이미 등록하신 상품(카테고리,프로그램)입니다.');
		} else if (resultMessage == 'ERR_DUPLICATE_ALARM') {
			alert('이미 등록하신 알림입니다.');
		} else if (resultMessage == 'ERR_SERVER_DELETE_FAIL') {
			alert('이미 삭제하신 상품(카테고리,프로그램)입니다.');
		} else if (resultMessage != 'ERR_SERVER_DELETE_VALIDATION_FAIL') {
			alert('오류가 발생하였습니다.');
		}
	};
});